




































































































import Vue from 'vue';
import Component from 'vue-class-component';
import AddressForm from '@/components/AddressForm.vue';
import { LabelInput, TextInput } from '@/components/FormInputs/FormInputs';

@Component({
	components: {
		AddressForm,
		LabelInput,
		TextInput,
	}
})
export default class SummaryView extends Vue {
	private isLoading: boolean = true;

	public async created() {
		this.$store.commit('InterviewModule/updatePageName', 'Summary');
		if (this.$route.params.refreshFormData) {
			await this.$store.dispatch('InterviewModule/getFormData', 'Summary');
		}
		this.isLoading = false;
	}

	public beforeDestroy() {
		this.$store.commit('InterviewModule/clearFormData');
	}

	private getDropdownLabelFromKey(dropdownKey: string, key: string): string {
		const options = this.getDropdownOptions(dropdownKey);
		return options.find(x => x.Key === key)?.Value || '';
	}

	private getRightsClaimedDisplayValues(): string {
		var rightCodes: string[] = this.getFormDataKey('Claim.RightCodes');
		return rightCodes.map(x => this.getDropdownLabelFromKey('Rights', x)).join(', ');
	}
}
